module.exports = __webpack_public_path__ + "media/images/edit-pencil-41d32a7d4e194b72e0e4af48a5ec20a5.svg";